<!-- 驳回的查看信息详情 -->
<template>
  <div id="app">
    <!-- <div id="top">
      <span class="rightcha">
        <img width="20px" src="../../assets/cha.png" />
        <span class="centerwz">我的订单</span>
      </span>
    </div> -->

    <div class="tbody">
      <div class="conent" v-for="(item, inde) in list" :key="inde">
        <div>
          <van-row
            type="flex"
            justify="space-between"
            class="conent-row"
            style="margin: 5px 0 8px 15px"
            gutter="20"
          >
            <van-col span="24">批次名称:{{ item.appraisalBatchName }}</van-col>
          </van-row>
        </div>
        <van-row
          type="flex"
          justify="space-between"
          style="margin: 15px 0 8px 15px"
          gutter="20"
        >
          <van-col style="margin-bottom: 10px" span="24"
            >考试科目:{{ item.subject }}</van-col
          >
        </van-row>
        <van-row
          type="flex"
          justify="space-between"
          style="margin: 15px 0 8px 15px"
          gutter="20"
        >
          <van-col style="margin-bottom: 10px" span="24"
            >考试工种:{{ item.examSubiectName }}</van-col
          >
        </van-row>
        <van-row
          type="flex"
          justify="space-between"
          style="margin: 15px 0 8px 15px"
          gutter="20"
        >
          <van-col style="margin-bottom: 10px" span="24"
            >考试等级:{{ item.examRank }}</van-col
          >
        </van-row>
        <van-row
          type="flex"
          justify="space-between"
          style="margin: 15px 0 8px 15px"
          gutter="20"
        >
          <van-col style="margin-bottom: 10px" span="24"
            >报名时间:{{
              $moment(item.examDate).format("YYYY-MM-DD HH:mm:ss")
            }}</van-col
          >
        </van-row>
        
        <van-row
          type="flex"
          justify="space-between"
          style="margin: 15px 0 8px 15px"
          gutter="20"
          v-if="item.examTime != null"
        >
          <van-col style="margin-bottom: 10px" span="24"
            >理论考试:{{ item.examTime }}</van-col
          >
        </van-row>
        <van-row
          type="flex"
          justify="space-between"
          style="margin: 15px 0 8px 15px"
          gutter="20"
          v-if="item.liveTime != null"
        >
          <van-col style="margin-bottom: 10px" span="24"
            >实操考试:{{ item.liveTime }}</van-col
          >
        </van-row>
        <!-- 理论的时候的地点 -->
        <van-row
          type="flex"
          justify="space-between"
          style="margin: 15px 0 8px 15px"
          gutter="20"
          v-if="item.subject == '理论'"
        >
          <van-col style="margin-bottom: 10px" span="24"
            >理论考试地点:{{ item.examAddress }}</van-col
          >
        </van-row>

        <!-- 实操的时候的地点 -->
        <van-row
          type="flex"
          justify="space-between"
          style="margin: 15px 0 8px 15px"
          gutter="20"
          v-if="item.subject == '实操'"
        >
          <van-col style="margin-bottom: 10px" span="24"
            >实操考试地点:{{ item.liveAddress }}</van-col
          >
        </van-row>

        <!-- 理论+实操的时候的地点 -->
        <van-row
          type="flex"
          justify="space-between"
          style="margin: 15px 0 8px 15px"
          gutter="20"
          v-if="item.subject == '理论，实操'||item.subject == '实操，理论'"
        >
          <van-col style="margin-bottom: 10px" span="24"
            >理论考试地点:{{ item.examAddress }}</van-col>
          <van-col style="margin-bottom: 10px" span="24"
            >实操考试地点:{{ item.liveAddress }}</van-col
          >
        </van-row>
        <van-row
          type="flex"
          justify="space-between"
          style="margin: 15px 0 8px 15px"
          gutter="20"
        >
          <van-col style="margin-bottom: 10px" span="24"
            >状态:{{ item.status }}</van-col
          >
        </van-row>
        <van-row
          type="flex"
          justify="space-between"
          style="margin: 15px 0 8px 15px"
          gutter="20"
        >
          <van-col style="margin-bottom: 10px" span="24"
            >驳回原因:{{ item.examReject }}</van-col
          >
        </van-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [],
      active: 0,
      statusObj: {
        unPay: "待支付",
        paid: "已支付",
        draft: "草稿",
        reject: "已驳回",
        unAppointment: "待预约",
        // 'unPay': '待支付',
        tested: "已考试",
        unTest: "未考试",
        toTest: "待考试",
        auditing: "审核中",
        examineePay: "考生交费",
        institutionPay: "机构交费",
      },
    };
  },
  created() {
    const params = {
      examOrderId: this.$route.query.examOrderId,
    };
    this.$http.post(`ExamOrder/Continue`, params).then((res) => {
      this.list = res.data.data.list;
      console.log(this.list)
      // this.list.forEach((element,index) => {
      //         element.statusText = this.statusObj[element.status]
      // })
    });
  },
};
</script>

<style scoped>
#app {
  background-color: #eee;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  font-size: 30px;
  width: 100%;
  height: 100vh;
}
#top {
  width: 100%;
  height: 70px;
  line-height: 70px;
  vertical-align: middle;
  /* padding-top: 40px; */
  background-color: rgba(245, 245, 245);
}
.rightcha {
  float: left;
}

.centerwz {
  /* display: block; */
  padding: 0px;
  font-size: 30px;
  line-height: 70px;
}
.conent {
  background-color: #fff;
}
.centtree {
  height: 350px;
  background-color: #fff;
}
</style>